<template>
  <div class="echartsModules" ref="echartsModules">
    <a-drawer
      title="资产变化趋势图"
      placement="right"
      :visible="visible"
      @close="handleCancel"
      width="90%"
      :destroyOnClose="true"
      :headerStyle="headerStyle"
    >
      <div class="modelDiv">
        <div class="leftDiv">
          <div class="treeDiv">
            <dept-tree
              ref="deptTree"
            ></dept-tree>
          </div>
          <a-divider />
          <div class="treeDiv2">
            <asset-tree ref="assetTree"></asset-tree>
          </div>
        </div>
        <div class="allAssetPurchasePriceDiv">
          <span>资产统计条数：{{ allAssetPurchasePrice }}条</span>
        </div>
        <div class="rightDiv">
          <a-tabs v-model="activeTab" @change="changeTabs">
            <a-tab-pane key="1" tab="变动总资产购置价值">
              <echarts-and-ul
                echartsId="echarts1"
                ref="echartsAndUl1"
                :searchModel="searchModel"
                :echartsSearchData="echartsSearchData"
                :activeTab="activeTab"
                @setAllAssetPurchasePrice="setAllAssetPurchasePrice"></echarts-and-ul>
            </a-tab-pane>
            <a-tab-pane key="2" tab="变动总资产现值总和">
              <echarts-and-ul
                echartsId="echarts2"
                ref="echartsAndUl2"
                :searchModel="searchModel"
                :echartsSearchData="echartsSearchData"
                :activeTab="activeTab"
                @setAllAssetPurchasePrice="setAllAssetPurchasePrice"></echarts-and-ul>
            </a-tab-pane>
            <a-tab-pane key="3" tab="变动总资产数量">
              <echarts-and-ul
                echartsId="echarts3"
                ref="echartsAndUl3"
                :searchModel="searchModel"
                :echartsSearchData="echartsSearchData"
                :activeTab="activeTab"
                @setAllAssetPurchasePrice="setAllAssetPurchasePrice"></echarts-and-ul>
            </a-tab-pane>
          </a-tabs>
          <div class="changeTimeDiv" v-if="showPrice">
            <a-select
              style="width: 160px;margin-right: 12px"
              placeholder="请选择未来时间"
              v-model="searchTime"
              @change="changeTime">
              <a-select-option v-for="(item, index) in timeList" :value="item.id" :key="index">
                {{ item.label }}
              </a-select-option>
            </a-select>
            <a-range-picker
              :placeholder="['开始', '结束']"
              format="YYYY-MM"
              :value="dateArr"
              :mode="mode"
              @panelChange="handlePanelChange2"
            />
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import deptTree from '@/views/assetLedger/modules/echartsModules/deptTree'
import assetTree from '@/views/assetLedger/modules/echartsModules/assetTree'
import echartsAndUl from '@/views/assetLedger/modules/echartsModules/echartsAndUl'
import searchTab from '@/views/assetLedger/modules/echartsModules/searchTab'
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  name: 'EchartsModules',
  components: {
    deptTree,
    assetTree,
    echartsAndUl,
    searchTab
  },
  computed: {
  },
  data () {
    return {
      visible: false,
      headerStyle: {
        textAlign: 'center'
      },
      // 搜索条件
      searchModel: {},
      // 日期范围选择
      dateArr: [],
      mode: ['month', 'month'],
      // 当前选中的时间
      activeBtn: 2,
      activeTab: '1',
      echartsSearchData: {},
      // 总资产购置价格
      allAssetPurchasePrice: 0,
      // 是否显示总资产购置价格
      showPrice: true,
      // 搜索时间
      searchTime: '本年',
      // 未来一到十年(1-10)
      timeList: [
        { id: '本月', label: '本月' },
        { id: '本年', label: '本年' },
        { id: '1', label: '近一年' },
        { id: '2', label: '近二年' },
        { id: '3', label: '近三年' },
        { id: '4', label: '近四年' },
        { id: '5', label: '近五年' },
        { id: '6', label: '近六年' },
        { id: '7', label: '近七年' },
        { id: '8', label: '近八年' },
        { id: '9', label: '近九年' },
        { id: '10', label: '近十年' }
      ]
    }
  },
  created () {
  },
  mounted () {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const date1 = year + '/01/01'
    const date2 = year + '/' + month + '/' + new Date(year, month, 0).getDate()
    this.dateArr = [moment(date1), moment(date2)]
    const data = {
      aktiv: this.dateArr[0].format('YYYY-MM-DD'),
      aktivEnd: this.dateArr[1].format('YYYY-MM-DD')
    }
    this.echartsSearchData = data
  },
  methods: {
    ...mapActions(['handleActiveTabs']),
    open (visible) {
      this.visible = visible
    },
    setSearchModel (searchModel) {
      this.searchModel = searchModel
    },
    handleCancel () {
      this.visible = false
    },
    // 选择时间
    changeTime (type) {
      if (type) {
        if (type === '本月') {
          // 本月
          const date = new Date()
          const year = date.getFullYear()
          const month = date.getMonth() + 1
          const date1 = year + '/' + month + '/01'
          const date2 = year + '/' + month + '/' + new Date(year, month, 0).getDate()
          this.dateArr = [moment(date1), moment(date2)]
        } else if (type === '本年') {
          const date = new Date()
          const year = date.getFullYear()
          const month = date.getMonth() + 1
          const date1 = year + '/' + '01/01'
          const date2 = year + '/' + month + '/' + new Date(year, month, 0).getDate()
          this.dateArr = [moment(date1), moment(date2)]
        } else {
          // 根据type来判断选择的时间，近1-10年，结束时间始终为当前时间，开始时间为当前时间减去type年
          const date = new Date()
          const year = date.getFullYear()
          const month1 = date.getMonth() + 2
          const month = date.getMonth() + 1
          // data1为开始时间，需要按照当前月份往前推，data2为结束时间，为当前时间
          const date1 = year - Number(type) + '/' + month1 + '/01'
          const date2 = year + '/' + month + '/' + new Date(year, month, 0).getDate()
          this.dateArr = [moment(date1), moment(date2)]
        }
        const data = {
          aktiv: this.dateArr[0].format('YYYY-MM-DD'),
          aktivEnd: this.dateArr[1].format('YYYY-MM-DD')
        }
        this.echartsSearchData = data
        this.$refs['echartsAndUl' + this.activeTab].getData(data, this.activeTab)
      }
      // this.activeBtn = type
      // if (type === 1) {
      //   const date = new Date()
      //   const year = date.getFullYear()
      //   const month = date.getMonth() + 1
      //   const date1 = year + '/' + month + '/01'
      //   const date2 = year + '/' + month + '/' + new Date(year, month, 0).getDate()
      //   this.dateArr = [moment(date1), moment(date2)]
      // } else if (type === 2) {
      //   const date = new Date()
      //   const year = date.getFullYear()
      //   const date1 = year + '/01/01'
      //   const date2 = year + '/12/31'
      //   this.dateArr = [moment(date1), moment(date2)]
      // } else if (type === 3) {
      //   const date = new Date()
      //   const year = date.getFullYear()
      //   const date1 = year - 2 + '/01/01'
      //   const date2 = year + '/12/31'
      //   this.dateArr = [moment(date1), moment(date2)]
      // }
      // const data = {
      //   aktiv: this.dateArr[0].format('YYYY-MM-DD'),
      //   aktivEnd: this.dateArr[1].format('YYYY-MM-DD')
      // }
      // this.echartsSearchData = data
      // this.$refs['echartsAndUl' + this.activeTab].getData(data, this.activeTab)
    },
    // 改变时间
    changeRangePicker (date) {
      const data = {
        aktiv: date[0].format('YYYY-MM-DD'),
        aktivEnd: date[1].format('YYYY-MM-DD')
      }
      this.echartsSearchData = data
      this.$refs['echartsAndUl' + this.activeTab].getData(data, this.activeTab)
    },
    handleChange (value) {
      console.log(value)
      this.dateArr = value
    },
    handlePanelChange2 (value, mode) {
      this.dateArr = value
      const datetime = new Date(this.dateArr[1])
      const year = datetime.getFullYear()
      const month = datetime.getMonth() + 1
      const date2 = year + '-' + month + '-' + new Date(year, month, 0).getDate()
      const data = {
        aktiv: this.dateArr[0].format('YYYY-MM-01'),
        aktivEnd: date2
      }
      this.echartsSearchData = data
      this.$refs['echartsAndUl' + this.activeTab].getData(data, this.activeTab)
      this.mode = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]
    },
    // 改变tab页
    changeTabs (type) {
      if (type !== '4') {
        this.showPrice = true
        this.$nextTick(() => {
          const data = {
            aktiv: this.dateArr[0].format('YYYY-MM-DD'),
            aktivEnd: this.dateArr[1].format('YYYY-MM-DD')
          }
          this.echartsSearchData = data
          this.$refs['echartsAndUl' + type].getData(data, type)
        })
      } else {
        this.showPrice = false
      }
    },
    // 改变总资产购置价格
    setAllAssetPurchasePrice (num) {
      this.allAssetPurchasePrice = num
    }
  }
}
</script>

<style scoped lang="less">
.modelDiv {
  //display: flex;
  height: 100%;
  .leftDiv {
    height: 100%;
    width: 200px;
    border-right: 1px solid #DDDDDD;
    padding-right: 10px;
    display: inline-block;
    float: left;
    .treeDiv {
      height: calc(48% - 10px);
      overflow-y: hidden;
    }
    .treeDiv2 {
      height: calc(51% - 10px);
      overflow-y: hidden;
    }
  }
  .allAssetPurchasePriceDiv {
    width: calc(100% - 200px);
    height: 50px;
    display: inline-block;
    padding-left: 10px;
    position: relative;
  }
  .allAssetPurchasePriceDiv span{
    display: inline-block;
    width: 100%;
    background-color: rgba(8, 64, 159, 0.1);
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    font-weight: 500;
  }
  .rightDiv {
    width: calc(100% - 200px);
    height: calc(100% - 50px);
    padding-left: 10px;
    position: relative;
    display: inline-block;
    .changeTimeDiv {
      display: flex;
      position: absolute;
      top: 4px;
      right: 0;
      .changeTimeBtn {
        margin-right: 10px;
        padding: 5px 10px;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.4s;
      }
      .changeTimeBtnActive {
        color: #ffffff;
        background: rgb(24, 144, 254);
        transition: all 0.4s;
      }
      /deep/.ant-calendar-picker-container {
        top: 40px !important;
      }
      .ant-calendar-picker {
        width: 180px;
      }
    }
  }
}
/deep/.ant-drawer-body {
  height: calc(100% - 55px);
  padding: 10px 24px 24px 24px;
}
/deep/.ant-tabs {
  height: 100%;
  .ant-tabs-content {
    height: calc(100% - 57px);
  }
}
</style>
